import { faInfoCircle, faPlus, faSearch } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { Button, Card, CardBody, Col, InputGroup, InputGroupAddon, Row, Alert, Input } from 'reactstrap';
import withRedirect from '../../helpers/hoc/withRedirect'
import ButtonIcon from '../common/ButtonIcon';
import FalconCardHeader from '../common/FalconCardHeader';
import Flex from '../common/Flex';
import PageHeader from '../common/PageHeader';
import useSWRFetchPagination from '../../helpers/hooks/useSWRFetchPagination';
import { getAllSurvey } from '../../helpers/api/survey';
import { useSelector } from 'react-redux';
import { isIterableArray, Message, Or, PreloadState } from '../UI/preloading/PreloadState';
import SurveyRow from './components/SurveyRow';
import VotationRow from './components/VotationRow';
import FullPagination from '../common/pagination/FullPagination';
import SupportLink from '../root/support/components/SupportLink';

const Surveys = () => {

    const location = useLocation();
    const history = useHistory();
    const [surveys, setSurveys] = useState(true);
    const { selectedCondominium } = useSelector(state => state.condominium);
    const { role } = useSelector(state => state.auth.user);
    const [textSearch, setTextSearch] = useState('');
    const [params, setParams] = useState({
        condominium: selectedCondominium,
        status: 0,
        survey: 1,
        search: null,
    });

    useEffect(() => {
        setParams((prev) => (
            prev.condominium === selectedCondominium
                ? prev
                : { ...prev, condominium: selectedCondominium }
        ));
    }, [selectedCondominium]);

    const applySurveySearch = (value = textSearch) => {
        const term = typeof value === 'string' ? value.trim() : '';
        setTextSearch(term);
        setParams((prev) => ({ ...prev, search: term || null }));
    };

    const {
        data,
        error,
        isLoading,
        mutate,
        meta,
        handler: { nextPage, previousPage, perPage, goToPage }
    } = useSWRFetchPagination(getAllSurvey, params, { ASC: true });

    useEffect(() => {
        mutate();
        // eslint-disable-next-line
    }, [surveys]);

    const RenderInteractionsItems = () => {
        return data.map((interaction, i) => interaction.survey === 1 ?
            <SurveyRow
                key={i}
                {...{
                    id: interaction.id,
                    author: interaction.author,
                    created_at: interaction.created_at,
                    due_date: interaction.due_date,
                    title: interaction.title,
                    survey: interaction.survey,
                    index: i
                }}
            />
            :
            <VotationRow
                key={i}
                {...{
                    id: interaction.id,
                    author: interaction.author,
                    created_at: interaction.created_at,
                    due_date: interaction.due_date,
                    title: interaction.title,
                    survey: interaction.survey,
                    index: i
                }} />)
    }

    return <>
        <PageHeader
            title="Encuestas/Votaciones" titleTag="h2"
            description={role === 'manager' ? 'Realiza la toma de decisiones encuestando a los propietarios.' : 'Encuestas del condominio.'}
            className="mb-3" col={{ lg: 9 }}
        >
            {role === 'manager' && <SupportLink />}
        </PageHeader>
        <Card>
            <FalconCardHeader title={surveys ? 'Encuestas' : 'Votaciones'} >
                <Row className='mb-3'>
                    <Col className='align-items-center justify-content-between' tag={Flex}>
                        <div>
                            <InputGroup>
                                <InputGroupAddon addonType='prepend'>
                                    <Button onClick={() => {
                                        setParams((prev) => { return { ...prev, survey: 1 } });
                                        setSurveys(true);
                                    }} disabled={!!params.survey} color={params.survey ? 'primary' : 'falcon-default'}>Encuestas</Button>
                                </InputGroupAddon>
                                <InputGroupAddon addonType='append'>
                                    <Button onClick={() => {
                                        setParams((prev) => { return { ...prev, survey: 0 } });
                                        setSurveys(false);
                                    }} disabled={!(!!params.survey)} color={!params.survey ? 'primary' : 'falcon-default'}>Votaciones</Button>
                                </InputGroupAddon>
                            </InputGroup>
                        </div>
                    </Col>
                    {role === 'manager' &&
                        <Col xs={12} md={'auto'} className='mt-3 mt-md-0 text-center text-md-right'>
                            <ButtonIcon tag={Link} to={`${location.pathname}/create/${surveys ? 1 : 0}`} color='falcon-default' icon={faPlus}>Añadir {surveys ? 'encuesta' : 'votación'}</ButtonIcon>
                        </Col>}
                </Row>
                <Row>
                    <Col className="d-flex">
                        <Input
                            type='text'
                            value={textSearch}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') applySurveySearch(e.target.value);
                            }}
                            onChange={(event) => {
                                const value = event.target.value;
                                setTextSearch(value);
                                if (!value.trim()) {
                                    setParams((prev) => ({ ...prev, search: null }));
                                }
                            }}
                            placeholder={`Buscar ${params.survey ? 'encuesta' : 'votación'} por título, detalle o autor...`}
                            className="d-inline-block search-input mr-2" />
                        <ButtonIcon icon={faSearch} className='d-inline-block text-nowrap' color='falcon-default' onClick={() => applySurveySearch()} >Buscar</ButtonIcon>
                    </Col>
                </Row>
            </FalconCardHeader>
            <CardBody className={isIterableArray(data) ? 'fs--1 p-0' : 'fs--1'}>
                <PreloadState cond={isIterableArray(data)} loading={isLoading}>
                    <Or value={true}>
                        <RenderInteractionsItems />
                    </Or>
                    <Or value={false} cond={!!error}>
                        <Or value={false} cond={role}>
                            <Or value={'manager'} cond={!!textSearch[0]}>
                                <Message value={true} color={'info'} className='p-3' align='left' icon={faInfoCircle}>
                                    <>No hemos encontrado una {surveys ? 'encuesta' : 'votacion'} con el nombre <b>"{textSearch}"</b>.</>
                                </Message>
                                <Message value={false} color={'info'} className='p-3' align='left' icon={faInfoCircle}>
                                    <>
                                        No hay {surveys ? 'encuestas' : 'votaciones'} registradas,
                                        Puedes crear uno en el botón <b>"Anadir {surveys ? 'encuesta' : 'votacion'}"</b>
                                    </>
                                </Message>
                            </Or>
                            <Or value={'property'} cond={!!textSearch[0]}>
                                <Message value={true} color={'info'} className='p-3' align='left' icon={faInfoCircle}>
                                    <>No hemos encontrado una {surveys ? 'encuesta' : 'votacion'} con el nombre <b>"{textSearch}"</b></>
                                </Message>
                                <Message value={false} color={'info'} className='p-3' align='left' icon={faInfoCircle}>
                                    <>Al parecer aún no hay {surveys ? 'encuestas' : 'votaciones'} por ahora.</>
                                </Message>
                            </Or>
                        </Or>
                        <Or value={true}>
                            <Alert color="danger" className="mb-0">
                                Esta página no está disponible
                                <Button data-testid="Button" color="link" size="sm" className="ml-1 pl-0" onClick={() => history.goBack()}>
                                    Volver
                                </Button>
                            </Alert>
                        </Or>
                    </Or>
                </PreloadState>
            </CardBody>
            {isIterableArray(data) &&
                <FullPagination
                    nextPage={nextPage}
                    prevPage={previousPage}
                    goToPage={goToPage}
                    meta={meta}
                    className={'shadow-none'}
                    posText={surveys ? 'Encuestas' : 'Votaciones'}
                    perPage={perPage} />
            }
        </Card>
    </>
}

export default withRedirect(Surveys);